/**
 * @description blob 工具类
 * @created 2024/04/28 10:39:52
 */

/**
 * @description blob 转 JSON
 * @created 2024/04/28 10:39:57
 */
export function blobToJson(blob, callback) {
  const reader = new FileReader()
  reader.onload = () => {
    const result = JSON.parse(reader.result)
    callback(result)
  }
  reader.readAsText(blob)
}
